<template>
  <div>
    <div class="mb-5">
      <p class="mb-2.5">
        {{ $t("we-provide-guarantee-period") }}
      </p>
      <LearnMore :link="guaranteeLearnMoreUrl" />
    </div>
  </div>
</template>

<script lang="ts">

import { ROUTES } from '~~/constants/routes';

export default defineComponent({
  name: 'PremiumGuarantee',

  setup() {

    const { getAdjustedSlug } = useRouteExtended();
    const guaranteeLearnMoreUrl = getAdjustedSlug(ROUTES.PREMIUM_GUARANTEE);

    return { guaranteeLearnMoreUrl };
  
  },
});

</script>
